import React from "react";
import { Link } from "react-router-dom";

import { connect } from "react-redux";

import { history } from "utils";
import { Icon, Breadcrumb } from "antd";

class Header extends React.Component {
  constructor(props) {
    super(props);
  }

  renderBreadcrumb() {
    const { title, bread } = this.props;
    if (!bread) return;

    return (
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/">
            <Icon type="home" />
          </Link>
        </Breadcrumb.Item>
        {(bread || []).map((b, i) => (
          <Breadcrumb.Item key={i}>
            {b.to ? (
              <Link to={b.to}>
                {b.icon && <Icon type={b.icon} />}
                <span>{b.text}</span>
              </Link>
            ) : (
              <span className="not-link">
                {b.icon && <Icon type={b.icon} />}
                <span>{b.text}</span>
              </span>
            )}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    );
  }

  render() {
    const { title, bread, subheader, beforeTitle } = this.props;

    return (
      <header className="page-header">
        {bread && this.renderBreadcrumb()}
        {!subheader ? (
          <h1>
            {bread && (
              <a className="back-icon" onClick={() => history.goBack()}>
                <Icon type="left" />
              </a>
            )}
            {beforeTitle && beforeTitle}
            {title}
          </h1>
        ) : (
          <h2>{title}</h2>
        )}
      </header>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
